/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as types from "../../types/primitives.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  EquipmentBrowserSection,
  EquipmentBrowserSection$inboundSchema,
  EquipmentBrowserSection$Outbound,
  EquipmentBrowserSection$outboundSchema,
} from "./equipmentbrowsersection.js";

export type EquipmentBrowserView = {
  /**
   * The section order of the equipment browser view
   */
  order: Array<string>;
  /**
   * The sections in the equipment browser view
   */
  sections: Array<EquipmentBrowserSection>;
};

/** @internal */
export const EquipmentBrowserView$inboundSchema: z.ZodType<
  EquipmentBrowserView,
  z.ZodTypeDef,
  unknown
> = z.object({
  order: z.array(types.string()),
  sections: z.array(EquipmentBrowserSection$inboundSchema),
});
/** @internal */
export type EquipmentBrowserView$Outbound = {
  order: Array<string>;
  sections: Array<EquipmentBrowserSection$Outbound>;
};

/** @internal */
export const EquipmentBrowserView$outboundSchema: z.ZodType<
  EquipmentBrowserView$Outbound,
  z.ZodTypeDef,
  EquipmentBrowserView
> = z.object({
  order: z.array(z.string()),
  sections: z.array(EquipmentBrowserSection$outboundSchema),
});

export function equipmentBrowserViewToJSON(
  equipmentBrowserView: EquipmentBrowserView,
): string {
  return JSON.stringify(
    EquipmentBrowserView$outboundSchema.parse(equipmentBrowserView),
  );
}
export function equipmentBrowserViewFromJSON(
  jsonString: string,
): SafeParseResult<EquipmentBrowserView, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => EquipmentBrowserView$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'EquipmentBrowserView' from JSON`,
  );
}
